import { Link, useParams } from "react-router";
import { usePropertiesQuery } from "../../api/queries";
import { slugify, titleCaseSlug } from "../../lib/format";
import { LogoTile } from "../../ui/LogoTile";
import { PageShell } from "../../ui/PageShell";

/**
 * `/demo-business/:slug`: the approved destination of every seeded demo listing points here, so
 * "Visit website" exercises the real outbound flow without sending anyone to a third party.
 */
export function DemoBusinessPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const q = usePropertiesQuery(true);
  const match = q.data?.items.find((p) => p.placement && slugify(p.placement.businessName) === slug);
  const name = match?.placement?.businessName ?? titleCaseSlug(slug) ?? "Demo business";
  return (
    <PageShell title={name} narrow>
      <div className="row" style={{ marginBottom: 12 }}>
        <LogoTile placement={match?.placement ?? null} size="lg" />
        <div>
          <span className="badge">Demo placeholder</span>
          {match ? <div className="small muted">{match.address}</div> : null}
        </div>
      </div>
      <div className="notice notice-info">
        <p style={{ margin: 0 }}>
          <strong>{name}</strong> is not a real company. It is a placeholder business that gives Townsy's development town a readable
          storefront. You reached this page through the same intentional “Visit website” link a real advertiser would get — nothing here is
          an advertisement, and arriving here only counts as an outbound click, never as proof that a page was read.
        </p>
      </div>
      {match?.placement?.shortDescription ? <p className="muted">{match.placement.shortDescription}</p> : null}
      <p className="hint">
        When a real business acquires this building, its approved destination replaces this page. Townsy reviews every destination and
        creative before it goes live.
      </p>
      <div className="row">
        {match ? (
          <Link className="btn btn-primary" to={`/place/${match.id}`}>
            Back to {name} in the town
          </Link>
        ) : (
          <Link className="btn btn-primary" to="/">
            Back to the town
          </Link>
        )}
        <Link className="btn" to="/directory">
          Directory
        </Link>
      </div>
    </PageShell>
  );
}
